<div class="container">
  <span *ngIf="suggestedResults.length === 0">
    {{ 'agent:panel.knowledge_base.no_result' | translate }}
  </span>
  <div class="expandAllButton" *ngIf="suggestedResults.length">
    <span *ngIf="!expandAll">{{ 'agent:panel.knowledge_base.expandAll' | translate }}</span>
    <span *ngIf="expandAll">{{ 'agent:panel.knowledge_base.reduceAll' | translate }}</span>
    <cng-switch [switchValue]="expandAll" (switchChange)="toggleExpandAll()"></cng-switch>
  </div>
  <knowledge-base-response-models-accordion
    *ngIf="suggestedResults.length"
    [responseModels]="suggestedResults"
    [canCopyPaste]="true"
    [expanded]="expandAll"
    [multi]="true"
  >
  </knowledge-base-response-models-accordion>
</div>
